//Copied from
//https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
import moment from "moment";
import { isEmpty, template } from "lodash";

export function itemListStyle(itemList) {
  if (!Array.isArray(itemList)) return {};
  else if (itemList.length === 1) {
    return {
      width: "33%",
      margin: "auto",
      gridTemplateColumns: "1fr"
    };
  } else if (itemList.length === 2) {
    return {
      width: "67%",
      margin: "auto",
      gridTemplateColumns: "repeat(2, 1fr)"
    };
  }
  return {};
}

export function determine_hostname() {
  if (typeof window.mmsKiosk !== "undefined") {
    return "ims-" + window.mmsKiosk.getIMSNumber() + ".box.mainstream-media.de";
  }
  if (process.env.NODE_ENV === "development") {
    return "ims-1-164.box.mainstream-media.de";
  }
}

export function setFixedPrice(combo) {
  if (combo.pricing_type === "fixed") {
    combo.components.forEach(component => {
      let product_data = component.available_products.find(
        ap => ap.id === component.selected.id
      );
      if (!component.selected.original_price) {
        component.selected.original_price = component.selected.price;
      }
      component.selected["price"] = product_data.price;
      component.selected["fixed_price"] = product_data.price;
    });
  }
}

export function getTranslatedMenuName($store, menu) {
  let menuDisplayName = getTranslation(
    $store,
    "Menu",
    "display_name",
    menu.id,
    menu.name
  );
  let first_product_name = "";
  if (!isEmpty(menu.components) && menu.components[0].selected) {
    first_product_name = getTranslation(
      $store,
      "Product",
      "display_name",
      menu.components[0].selected.id,
      menu.components[0].selected.name
    );
  }
  let tpl = template(menuDisplayName, {
    interpolate: /{([\s\S]+?)}/g
  });
  let result = tpl({
    product: first_product_name
  }).trim();
  if (isEmpty(result)) return menu.name;
  return result;
}

export function getPotentialMenus(
  available_menus,
  product_menu_ids,
  with_promos
) {
  let potential_menus = product_menu_ids.flatMap(menu_id => {
    let m = available_menus.find(menuitem => menuitem.id === menu_id);
    return m ? [m] : [];
  });
  if (!with_promos)
    potential_menus = potential_menus.filter(m => m.pricing_type !== "fixed");
  potential_menus = potential_menus.sort((m1, m2) => m1.order_by - m2.order_by);
  return potential_menus;
}

export function cssVarValue(cssVarName) {
  let style = getComputedStyle(document.body);
  let prop = style.getPropertyValue(cssVarName);
  if (prop) {
    return prop.trim();
  } else {
    return "";
  }
}

export function cssVarBoolean(cssVarName) {
  let value = cssVarValue(cssVarName);
  switch (value.toLowerCase().trim()) {
    case "true":
    case "1":
      return true;
    default:
      return false;
  }
}

export function isBackgroundImageSet(cssVarName) {
  let value = cssVarValue(cssVarName);
  switch (value.toLowerCase().trim()) {
    case "none":
    case "":
      return false;
    default:
      return true;
  }
}

const assetsContext = require.context("@/assets/", true, /\.webm$/);

export function determineVideoSrc(propertyPrefix, videoName) {
  console.log("value: " + propertyPrefix + videoName);
  let value = cssVarValue(propertyPrefix + videoName);
  console.log("value: " + value);

  if (value && value.toLowerCase().trim() !== "none") {
    return value;
  } else {
    return videoName ? assetsContext(`./${videoName}.webm`) : "";
  }
}

export function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function shuffleArray(array) {
  let currentIndex = array.length,
    temporaryValue,
    randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
}

export function generate_random_string(length) {
  let result = "";
  let characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function generate_reference() {
  var result = "order-" + moment().format("YYYYMMDDHHmmss") + "-";
  result += generate_random_string(11);
  return result;
}

export function getTranslations(store, klass, attr, id, def) {
  let translations = {};
  let languages = store.getters.LANGUAGES;
  let all_translations = store.getters.TRANSLATIONS;
  if (!languages) return [];
  languages.forEach(language => {
    let current_translation = all_translations[language.code_short];
    let key = klass + "-" + attr + "-" + id;
    let elem = current_translation[key];
    if (elem) {
      translations["display_name_" + language.code_short] = elem;
    }
  });

  return translations;
}

export function getTranslation(store, klass, attr, id, def) {
  let translation = store.getters.ACTIVE_TRANSLATION;
  if (!translation) return def;
  let key = klass + "-" + attr + "-" + id;
  let elem = translation[key];
  if (!elem) return def;
  return elem;
}

export const opacityAnimation = (element, config, callback) => {
  let elem = document.getElementById(element);
  let id;
  const { from, to, step } = config;
  let i = 0;
  const steps = Math.abs(Math.abs(from) - Math.abs(to)) / Math.abs(step);
  let opacity = from;

  function frame() {
    if (i >= steps) {
      if (callback) {
        callback();
      }
      clearInterval(id);
    } else {
      opacity += step;
      i++;
      elem.style.opacity = opacity;
    }
  }

  if (elem) {
    id = setInterval(frame, 20);
  }
};

export const transitionAnimation = (element, config, callback) => {
  let elem = document.getElementById(element);
  let id;
  const { start, end, move, condition } = config;
  if (elem) {
    id = setInterval(frame, condition.speed);
  } else {
    return;
  }
  const internal = {
    height: start.height,
    width: start.width,
    top: start.top,
    left: start.left
  };

  if (condition.zIndex) {
    elem.style.zIndex = condition.zIndex;
  }

  let i = 0;
  const checkCondition = name => {
    return (
      (move[name] > 0 && internal[name] < end[name]) ||
      (move[name] < 0 && internal[name] > end[name])
    );
  };

  function frame() {
    if (i > condition.steps) {
      clearInterval(id);
      elem.style.height = `${end.height}px`;
      elem.style.width = `${end.width}px`;
      elem.style.left = `${end.left}px`;
      elem.style.top = `${end.top}px`;
      if (callback) {
        callback();
      }
    } else {
      if (checkCondition("height")) {
        internal.height += move.height;
      }
      if (checkCondition("width")) {
        internal.width += move.width;
      }
      if (checkCondition("left")) {
        internal.left += move.left;
      }
      if (checkCondition("top")) {
        internal.top += move.top;
      }
      i += condition.step;
      elem.style.height = internal.height + "px";
      elem.style.width = internal.width + "px";
      elem.style.left = internal.left + "px";
      elem.style.top = internal.top + "px";
    }
  }
};
